export default {
    showButton: 'Contact',
    calendlyButton: 'Make appointment',
    title: 'Contact',
    url: 'https://calendly.com/trendexplorer/innovation-tool-livedemo-45-minutes-english-klon?embed_domain=www.trendmanager.com&amp;embed_type=Inline',
    info: '<p>Would you like to learn more about the trend radar and the tool? We would be happy to present the trend radar and other functions of the trend manager to you without obligation.</p>' +
    '<p>Please feel free to contact me at:</p>',
    phone: 'PHONE: {number}',
    mobile: 'MOB: {number}',
    email: 'MAIL'
}
